import { motion } from "framer-motion";
import { Plus } from "lucide-react";

const AddButton = ({ children, disabled, ...props }) => {

  return (
    <motion.button
      type="button"
      aria-label={typeof children === "string" ? children : undefined}
      title={typeof children === "string" ? children : undefined}
      className={`photon-add-button group flex items-center justify-center h-[26px] p-[7.5px] rounded-full border-[0.5px] ${
        disabled
          ? 'bg-button-add-disabled-surface border-button-add-disabled-border cursor-not-allowed'
          : 'bg-button-add-surface hover:bg-button-add-hover border-button-add-border dark:bg-button-add-surface'
      }`}
      whileHover={disabled ? undefined : "hover"}
      initial="initial"
      animate="initial"
      disabled={disabled}
      {...props}
    >
      <Plus className={`w-3 h-3 flex-shrink-0 ${disabled ? 'text-button-disabled-text' : 'text-button-control-text'}`} strokeWidth={2} />
      <motion.span
        className={`text-xs overflow-hidden whitespace-nowrap ${disabled ? 'text-button-disabled-text' : 'text-button-control-text'}`}
        variants={{
          initial: { width: 0, opacity: 0 },
          hover: disabled ? {} : {
            width: "auto",
            opacity: 1,
            marginLeft: "5px",
            transition: { duration: 0.3, ease: "easeInOut" },
          },
        }}
      >
        {children}
      </motion.span>
    </motion.button>
  );
};

export default AddButton;
